module.exports = __webpack_public_path__ + "assets/images/vcr_hotel-03.0f97056ad73012778e21253100e31bdb.svg";